var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeButtons
    ? _c("div", { staticClass: "page-functions" }, [
        _c(
          "ul",
          {
            staticClass: "page-functions__list",
            class: [
              _vm.orientation === "h"
                ? "page-functions__list--horizontal"
                : "page-functions__list--vertical",
              `page-functions__list--align-${_vm.align}`,
            ],
          },
          [
            _vm.activeButtons.print
              ? _c(
                  "li",
                  { staticClass: "page-functions__item" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Print",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "page-functions__button",
                            on: { click: _vm.printPage },
                          },
                          [_c("Icon", { attrs: { icon: "print" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.pdfDownload
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: _vm.showLabels
                      ? "page-functions__item--labeled"
                      : "page-functions__item",
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: _vm.downloadEnabled
                            ? "Download PDF"
                            : "Please save the report to download.",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "repDownload",
                            class: _vm.downloadEnabled
                              ? "page-functions__button"
                              : "page-functions__button--disabled",
                            on: { click: _vm.pdfDownload },
                          },
                          [
                            _c("Icon", { attrs: { icon: "pdf-download" } }),
                            _vm._v(" "),
                            _vm.showLabels
                              ? _c("div", { staticClass: "button-label" }, [
                                  _vm._v("Download (PDF)"),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.excelDownload
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: _vm.showLabels
                      ? "page-functions__item--labeled"
                      : "page-functions__item",
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: _vm.downloadEnabled
                            ? "Download Excel"
                            : "Please save the report to download.",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "repDownload",
                            class: _vm.downloadEnabled
                              ? "page-functions__button"
                              : "page-functions__button--disabled",
                            on: { click: _vm.excelDownload },
                          },
                          [
                            _c("Icon", { attrs: { icon: "xlsx-download" } }),
                            _vm._v(" "),
                            _vm.showLabels
                              ? _c("div", { staticClass: "button-label" }, [
                                  _vm._v("Download (Excel)"),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.emailToContact
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: { "item-labeled": _vm.showLabels },
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Send email to contacts",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "page-functions__button",
                            on: { click: _vm.emailToContact },
                          },
                          [_c("Icon", { attrs: { icon: "email" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.bookmark
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: { "item-labeled": _vm.showLabels },
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Add to Bookmarks",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "page-functions__button",
                            on: { click: _vm.checkBookmark },
                          },
                          [
                            !_vm.isBookmark
                              ? _c("Icon", { attrs: { icon: "bookmark" } })
                              : _c("Icon", {
                                  attrs: { icon: "bookmark-full" },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.emailToAuthor && _vm.articleAuthor
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: { "item-labeled": _vm.showLabels },
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Send email to author",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "page-functions__button",
                            on: { click: _vm.emailToAuthor },
                          },
                          [_c("Icon", { attrs: { icon: "write-email" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.copy
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: { "item-labeled": _vm.showLabels },
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Copy",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "page-functions__button",
                            on: { click: _vm.copy },
                          },
                          [_c("Icon", { attrs: { icon: "copy" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.addNote
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: { "item-labeled": _vm.showLabels },
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Add",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "page-functions__button",
                            on: { click: _vm.addNote },
                          },
                          [_c("Icon", { attrs: { icon: "add-note" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    (_vm.notes && _vm.notes.length) || _vm.amountNotes
                      ? _c("NoteButton", {
                          attrs: {
                            content:
                              _vm.notes && _vm.notes.length
                                ? _vm.notes.length
                                : "" || _vm.amountNotes,
                          },
                          on: { clickNoteButton: _vm.showAllNotes },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.pinNote
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: { "item-labeled": _vm.showLabels },
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Pin",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "page-functions__button",
                            on: { click: _vm.pinNote },
                          },
                          [_c("Icon", { attrs: { icon: "pin" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.editNote
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: { "item-labeled": _vm.showLabels },
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Edit",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "page-functions__button",
                            on: { click: _vm.editNote },
                          },
                          [_c("Icon", { attrs: { icon: "edit" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeButtons.removeNote
              ? _c(
                  "li",
                  {
                    staticClass: "page-functions__item",
                    class: { "item-labeled": _vm.showLabels },
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Remove",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "page-functions__button",
                            on: { click: _vm.removeNote },
                          },
                          [_c("Icon", { attrs: { icon: "remove" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }